
import {Component, Prop, Watch} from "vue-property-decorator";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import NafakaAlacakKalemiForm from "@/components/forms/alacak-kalemi/NafakaAlacakKalemiForm.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import MahkemeSecim from "@/components/inputs/MahkemeSecim.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import {ParaBirimi} from '@/enum/ParaBirimi';
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import {TakipMahiyeti} from "@/enum/TakipMahiyeti";
import {TakipTipi} from "@/enum/TakipTipi";
import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  components: {
    ProtestoIhtarForm,
    DovizTakipSekliPicker,
    Kur,
    StepperValidationForm,
    DosyaEsasNumarasi,
    ParaBirimiPicker,
    Tutar,
    Dates,
    NafakaAlacakKalemiForm,
    AyEkleForm,
    ItemArrayManager,
    MahkemeSecim,
  },
})
export default class IlamsizNafakaAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTipiId!: number;
  @Prop() takipTalebi !: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  activeStep = 1;
  mahkemeAdi: string = "";
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  takipMahiyeti = TakipMahiyeti;

  stepperHeaders = [
    "Nafaka Alacağı",
    "İhtar",
    "Alacak Kalemi"
  ];

  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 12,
    dosya: 1
  }

  get takipMahiyetiNafaka(){
    const ilkTalep =
        this.$store.state.takipEkle?.item
            ?.takip_bilgileri
            ?.talepler
            ?.[0];
    if (ilkTalep?.takip_mahiyeti_id == this.takipMahiyeti.nafaka) {
      return true;
    }
    return false;
  }

  get showNafakaBitisTarihi() {
    const takip = this.$store.state.takipDetay?.takip;
    const ilkTalep = takip?.takip_bilgileri?.talepler?.[0];
    const takipTipiId = ilkTalep?.takip_tipi_id;
    const takipMahiyetiId = ilkTalep?.takip_mahiyeti_id;

    return (takipTipiId === TakipTipi.ilamsiz || takipTipiId === TakipTipi.paraBorcuVeyaTeminat)
        && takipMahiyetiId == TakipMahiyeti.nafaka;
  }

  get visibleStepperHeaders() {
    if (!this.localValue.ihtar_var_mi) {
      return this.stepperHeaders.filter(header => header !== "İhtar");
    }
    return this.stepperHeaders;
  }

  @Watch('localValue.ihtar_var_mi')
  onIhtarVarMiChange() {
    if (this.localValue.ihtar_var_mi) {
      if (!this.localValue.ihtarlar) {
        this.$set(this.localValue, 'ihtarlar', [{}]);
      } else if (this.localValue.ihtarlar.length === 0) {
        this.localValue.ihtarlar.push({});
      }
    } else {
      delete this.localValue.ihtarlar;
      if (this.activeStep === 2) {
        this.activeStep = 1;
      }
    }
    this.input();
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      this.$delete(this.localValue, 'doviz_kur_tarihi');
    }
    this.input();
  }

  mounted() {
    this.$emit('hide-button', true);

    if (!this.localValue.asil_alacaklar) {
      this.$set(this.localValue, 'asil_alacaklar', [{}]);
    } else if (this.localValue.asil_alacaklar.length === 0) {
      this.localValue.asil_alacaklar.push({});
    }

  }

  previousStepRules() {
    return true;
  }

  nextStepRules() {
    return true;
  }

  nextStep() {
    if (this.activeStep === this.visibleStepperHeaders.length) {
      this.save();
    } else if (this.activeStep < this.visibleStepperHeaders.length) {
      this.activeStep++;
    }
    this.nextStepRules();
  }
}
